import permissionManager from './PermissionManager'

// Checks for view permissions to enable tabs in quickview
export const isAllowedToViewTab = (assetId) => {
  return permissionManager.hasPermissionForTab(assetId, 'view')
}

export const isAllowedToEditTab = (assetId) => {
  return permissionManager.hasPermissionForTab(assetId, 'update')
}

export const isAllowedToPerformFeature = (featureName) => {
  return permissionManager.hasPermissionForFeature(featureName)
}

// Check for various permission levels
export const isAllowedToView = (featureName) =>
  isAllowedToPerformFeature(`${featureName}.view`)

export const isAllowedToUpdate = (featureName) =>
  isAllowedToPerformFeature(`${featureName}.update`)

export const isAllowedToCreate = (featureName) =>
  isAllowedToPerformFeature(`${featureName}.create`)

export const isAllowedToDelete = (featureName) =>
  isAllowedToPerformFeature(`${featureName}.remove`)

export const isAllowedToOverride = (featureName) =>
  isAllowedToPerformFeature(`${featureName}.override`)

export const isAllowedToImport = (featureName) =>
  isAllowedToPerformFeature(`${featureName}.import`)

export const isAllowedToManageData = () =>
  isAllowedToPerformFeature('Data Management')

export const hasObjectPermission = (id, type) => {
  if (isAllowedToViewAdminAccess()) {return true}
  return permissionManager.hasObjectPermission(id, type)
}

export const crudHeaderPermission = (header, level) => {
  if (isAllowedToViewAdminAccess()) {
    return true
  }

  const objectLevelTypes = {
    'entities': 'entities',
    'accounts': 'contract',
    'buildings': 'asset',
    'locations': 'asset'
  }

  const globalTypes = {
    'users': `user.${level}`,
    'people': `party.${level}`,
    'services': `service.${level}`,
    'skill sets': `skillset.${level}`,
    'operational groups': `group.operational.${level}`,
    'user groups': `group.user.${level}`,
    'feature groups': `group.feature.${level}`,
    'territory groups': `group.territory.${level}`,
    'commercial zones': `datazone.commercial.${level}`,
    'geo zones': `datazone.geo.${level}`
  }

  if (objectLevelTypes[header.toLowerCase()])
  {
    return permissionManager.hasObjectTypePermission(objectLevelTypes[header.toLowerCase()], level)
  }

  if (globalTypes[header.toLowerCase()])
  {
    return isAllowedToPerformFeature(globalTypes[header.toLowerCase()])
  }

  return false
}

export const isAllowedToViewAdminAccess = () =>
  permissionManager.isAdmin()

// Function to check if the user can access the admin dashboard
export const isAllowedToAccessAdminDashboard = () =>
  permissionManager.isAllowedToAccessAdminDashboard()

// Function to check quick view permission
export const checkQuickViewPermission = (setAllowed, permissions) => {
  permissionManager.checkQuickViewPermission(setAllowed, permissions)
}
